import React, { useEffect, useState } from "react";
import api from "../../services/api";

const badgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 21,
  height: 21,
  padding: "0 6px",
  borderRadius: 11,
  background: "#DC2626",
  color: "#FFFFFF",
  fontSize: 11,
  fontWeight: 850,
  lineHeight: 1,
  flexShrink: 0
};

const readPendingCount = async ticketId => {
  const response = await api.get(
    `/korax-forms/requests/ticket/${encodeURIComponent(ticketId)}`
  );

  const requests = response.data?.requests;

  if (!Array.isArray(requests)) {
    throw new Error("Lista de formularios inesperada");
  }

  const submitted = requests.filter(
    item => item?.status === "submitted" && item?.id
  );

  let count = 0;

  // Lotes pequenos evitam sobrecarregar o backend.
  for (let i = 0; i < submitted.length; i += 5) {
    const batch = submitted.slice(i, i + 5);

    const results = await Promise.all(
      batch.map(async item => {
        const detail = await api.get(
          `/korax-forms/requests/${encodeURIComponent(item.id)}/submission`
        );

        const submission = detail.data?.submission ||
          detail.data?.request?.submission;

        if (!submission) {
          throw new Error("Resposta indisponivel");
        }

        return submission.importedAt ? 0 : 1;
      })
    );

    count += results.reduce(
      (total, value) => total + value,
      0
    );
  }

  return count;
};

export default function KoraxFormPendingBadge({
  ticketId,
  open
}) {
  const [state, setState] = useState({
    loading: false,
    count: 0,
    error: false
  });

  useEffect(() => {
    if (!open || !ticketId) return undefined;

    let active = true;

    setState({
      loading: true,
      count: 0,
      error: false
    });

    readPendingCount(ticketId)
      .then(count => {
        if (!active) return;

        setState({
          loading: false,
          count,
          error: false
        });
      })
      .catch(() => {
        if (!active) return;

        setState({
          loading: false,
          count: 0,
          error: true
        });
      });

    return () => {
      active = false;
    };
  }, [ticketId, open]);

  if (!open || !ticketId) return null;

  if (state.loading) {
    return (
      <span
        title="Verificando respostas"
        style={{
          color: "#94A3B8",
          fontSize: 11
        }}
      >
        …
      </span>
    );
  }

  if (state.error) {
    return (
      <span
        title="Não foi possível verificar as pendências"
        style={{
          color: "#D97706",
          fontWeight: 800,
          fontSize: 13
        }}
      >
        !
      </span>
    );
  }

  if (state.count === 0) return null;

  return (
    <span
      style={badgeStyle}
      title={`${state.count} resposta(s) aguardando importação`}
      aria-label={`${state.count} formulários pendentes de importação`}
    >
      {state.count > 99 ? "99+" : state.count}
    </span>
  );
}
